import React from 'react';
import { getFormattedDate } from '../../../../helpers/localize';
import { useParams } from 'react-router-dom';
import { TABLE_KEYS } from '../../../../redux_store/reducer/reducers/tableReducer/tableReducer';
import DownloadTableFile from '../../../Shared/Table/widgets/TopBar/DownloadTableFile';
import { useDispatch, useSelector } from 'react-redux';
import {
  INFO_PANE_PAGES,
  openInfoPane,
} from '../../../../redux_store/reducer/reducers/infoPaneReducer';
import { useTheme } from '@material-ui/core';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import BaseMenuItem from '../../../Shared/Table/widgets/TopBar/MenuItem/BaseMenuItem';
import MetricsButton from '../../../Shared/Table/widgets/MetricsButton';

const TableActions = (props) => {
  const { accountUuid: paramAccountUuid } = useParams();
  const tableKey = paramAccountUuid ? TABLE_KEYS.claimsDSTable : TABLE_KEYS.claimsTable;

  return <>
    <MetricsButton title={'claims'} aggregations={props.aggregations} filter={props.filter}/>
    <DownloadTableFile
      fileName={`Claims ${getFormattedDate(new Date(Date.now()))}.csv`}
      endpoint={'/export-claims.csv'}
      tableKey={tableKey}
      {...props}
    /></>;
};

export default TableActions;
